<template>
  <div class="uc-Exam-box">
    <section class="g-headerExam">
      <div class="container">
        <div class="row">
          <div class="col-24 box">
            <router-link to="/" class="logo"
              ><img :src="$store.getters.user.company_logo"
            /></router-link>
            <div class="title">考试排行榜</div>
          </div>
        </div>
      </div>
    </section>
    <div class="g-headerExamSpace"></div>

    <section class="container-fluid g-ExamPercentBox">
      <div class="container">
        <div class="col-24 box">
          <div class="title">{{ model.paper_name }}</div>
        </div>
      </div>
    </section>
    <div class="g-ExamPercentBoxSpace"></div>

    <section class="container-fluid uc-bg g-examInfo">
      <div class="container">
        <div class="box">
          <div class="item">
            <span class="txt">试 卷 总 分：</span>{{ model.total_score }}分
          </div>
          <div class="item">
            <span class="txt">通 过 分 数：</span>{{ model.pass_score }}分
          </div>
          <div class="item">
            <span class="txt">评 分 方 式：</span
            >{{ model.score_way == 1 ? '自动' : '手动' }}
          </div>
          <div class="item">
            <span class="txt">最 高 分 数：</span>{{ model.max_score }}分
          </div>
          <div class="item">
            <span class="txt">最 低 分 数：</span>{{ model.min_score }}分
          </div>
          <div class="item">
            <span class="txt">平 均 分 数：</span>{{ model.min_score }}分
          </div>
          <div class="item">
            <span class="txt">试 卷 总 数：</span>{{ model.total_count }}个
          </div>
          <div class="item">
            <span class="txt">有 效 试 卷：</span>{{ model.valid_count }}个
          </div>
          <div class="item">
            <span class="txt">无 效 试 卷：</span>{{ model.invalid_count }}个
          </div>
          <div class="item">
            <span class="txt">通 过 数 量：</span>{{ model.pass_count }}个
          </div>
          <div class="item">
            <span class="txt">未通过数量：</span>{{ model.un_pass_count }}个
          </div>
          <div class="item">
            <span class="txt"><i class="e">通</i><i class="e">过</i>率：</span
            >{{ model.pass_percent }}
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-StatisticsList">
      <div class="container">
        <div class="box">
          <table style="text-align: center; table-layout: fixed">
            <tr>
              <th style="width: 12%">姓名</th>
              <th style="width: 12%">用户名</th>
              <th style="width: 30%">考试时间</th>
              <th style="width: 8%">耗时(分)</th>
              <th style="width: 8%">成绩</th>
              <th style="width: 8%">排名</th>
            </tr>
            <tr v-for="(item, index) in model.rank_list" :key="index">
              <td>{{ item.first_name }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.start_time }} -- {{ item.end_time }}</td>
              <td>{{ Math.round(item.spent_time / 60) }}</td>
              <td>{{ item.total_score }}</td>
              <td>{{ item.rank }}</td>
            </tr>
            <tr v-if="model.rank_list.length == 0">
              <td colspan="6">暂无数据</td>
            </tr>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ExamRanking',
  components: {},
  data() {
    return {
      query: {
        id: this.$route.params.id,
      },
      model: {
        rank_list: [],
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getRanking();
    },
    async getRanking() {
      const response = await this.$api.exam.getRanking(this.query);
      const { code, data } = response.data;
      this.model = data;
    },
  },
};
</script>
